"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
const bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");
const listStyles = (props) => {
    const { theme, hideIcon = false } = props;
    return (0, styled_components_1.css) `
    margin-bottom: ${theme.spacing.unit * 3}px;
    margin-top: 0;
    padding-left: ${theme.spacing.unit * 4}px;

    font-size: 14px;

    & > li {
      margin-bottom: ${theme.spacing.unit}px;
    }

    & > li:last-child {
      margin-bottom: 0;
    }

    ${hideIcon &&
        (0, styled_components_1.css) `
      list-style: none;
      padding-left: 0;
    `}

    ${bitcoincom_pkg_theme_1.media.md `
      font-size: 20px;
    `}
  `;
};
exports.default = listStyles;
//# sourceMappingURL=commonStyles.js.map